<template lang="pug">
.content-wrap
  .content-top
    .con
      .inbox-wrapper
        .proinfo.pointer(@click="$helpers.redirect('deposit')")
          .probals.s2
            .label {{$t('ui.balance')}}
            .amount
              span MYR {{ $numeral($store.getters.balance).format("0,0.00") }}
              i.far.fa-eye
        .inboxes
          .iin
            .label Bonus Categories
            .bcats-wrapper(v-if="startRender")
              .bcats
                .iimg
                  img(src='/new/img/af/inbox/ib-levelup.png')
                .ttext
                  small Level-Up Reward
                  span MYR {{ $numeral(rewards[0].vip_reward).format("0,0.00") }}
              .bcats
                .iimg
                  img(src='/new/img/af/inbox/ib-cashback.png')
                .ttext
                  small Daily Cashback
                  span MYR {{ $numeral(rewards[0].rescue_fund).format("0,0.00") }}
              .bcats
                .iimg
                  img(src='/new/img/af/inbox/ib-rebate.png')
                .ttext
                  small Daily Rebate
                  span MYR {{ $numeral(rewards[0].rebate_self).format("0,0.00") }}
              .bcats
                .iimg
                  img(src='/new/img/af/inbox/ib-refer.png')
                .ttext
                  small Referral Commission
                  span MYR {{ $numeral(rewards[0].rebate_downline).format("0,0.00") }}
              .bcats
                .iimg
                  img(src='/new/img/af/inbox/ib-mission.png')
                .ttext
                  small Mission Reward
                  span MYR {{ $numeral(rewards[0].smartico).format("0,0.00") }}
        .inboxes
          .iin
            .label Bonus Transactions
            .btrans-wrapper
              div Only the latest 30 days transactions will be displayed below.
              .btrans-table.statement-desktop
                table
                  thead
                    tr
                      th Date/Time
                      th Bonus Name
                      th {{$t('ui.amount')}}
                      th {{$t('ui.date_expiry')}}
                      //- th {{ $t('ui.remarks') }}
                      th
                  tbody(v-if="startRender")
                    template(v-if="inboxList.length > 0")
                      tr(v-for="(msg, index) in inboxList" )
                        td {{ $moment(msg.created_date).format("YYYY-MM-DD HH:mm:ss") }}
                        td(v-if="pB.includes(msg.remark)") {{pbName[msg.remark]}}
                        td(v-else) {{msg.campaign_name}}
                        td MYR {{ msg.amount }}
                        td {{ $moment(msg.expiry_date).format("YYYY-MM-DD HH:mm:ss") }}
                        //- td(v-if="msg.remark !== null") {{msg.remark}}
                        //- td(v-else) -
                        td
                          a.btn-claim.pointer(v-if="!loading" @click="claimAction(msg.id)") {{$t('ui.claim')}}
                          a.btn-claim.disabled-grey(v-else style="min-width: 50px")
                            i.fas.fa-duotone.fa-spinner.fa-spin-pulse.text-black
                    template(v-else)
                      tr
                        td.text-center(colspan="6") {{ $t("ui.no_new_message") }}
                  tbody(v-else)
                    tr
                      td.text-center(colspan="6")
                        i.fas.fa-duotone.fa-spinner.fa-spin-pulse.text-black
              .statement-mobile.bg-white.text-black(style="font-size:12px")
                hr
                template(v-if="inboxList.length > 0")
                  .statement-single(v-for="(msg, index) in inboxList" )
                    .statement-single-content.p-0
                      .statement-date {{ $moment(msg.created_date).format("YYYY-MM-DD HH:mm:ss") }}
                      .statement-detail
                        .statement-detail-left Bonus Name
                        .statement-detail-right
                          a(v-if="pB.includes(msg.remark)" href='javascript:void(0)') {{pbName[msg.remark]}}
                          a(v-else href='javascript:void(0)') {{msg.campaign_name}}
                      .statement-detail
                        .statement-detail-left {{$t('ui.amount')}}
                        .statement-detail-right MYR {{ msg.amount }}
                      .statement-detail
                        .statement-detail-left {{$t('ui.date_expiry')}}
                        .statement-detail-right {{ $moment(msg.expiry_date).format("YYYY-MM-DD HH:mm:ss") }}
                      .text-center.mt-2.mb-2
                        a.btn-claim.pointer.w-25(v-if="!loading" @click="claimAction(msg.id)") {{$t('ui.claim')}}
                        a.btn-claim.disabled-grey.w-25(v-else style="min-width: 50px")
                          i.fas.fa-duotone.fa-spinner.fa-spin-pulse.text-black
                    hr
                template(v-else)
                  .statement-single.text-center {{ $t("ui.no_new_message") }}
</template>
<script>
export default {
  data(){
    return{
      feedback: {
        success: true,
        status: ""
      },
      loading: false,
      startRender: false,
      pB: [
        "A", "B", "C", "D", "E", "F", "G", "H", "I", "J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z","AA","LB","WD1","WD2","WD3","WD4","WD5","WD6","WD7","WD8", "MT1","MT2","MT3","MT4","MT5","MT6","MT7","MT8","MT9", "R1","R2","R3","R4","R5","R6","R7","R8","R9","R10","R11","R12","R13","R14","R15","R16","R17","R18","R19","R20","R21","R22","R23","R24","R25","R26","R27","R28","R29"
      ],
      pbName: {
        "A" : "Wheel Reward",
        "B" : "Wheel Reward",
        "C" : "Wheel Reward",
        "D" : "Wheel Reward",
        "E" : "Wheel Reward",
        "F" : "Wheel Reward",
        "G" : "Wheel Reward",
        "H" : "Wheel Reward",
        "I" : "Wheel Reward",
        "J" : "Wheel Reward",
        "K" : "Wheel Reward",
        "L" : "Wheel Reward",
        "M" : "Wheel Reward",
        "N" : "Wheel Reward",
        "O" : "Wheel Reward",
        "P" : "Wheel Reward",
        "Q" : "Wheel Reward",
        "R" : "Wheel Reward",
        "S" : "Wheel Reward",
        "T" : "Wheel Reward",
        "U" : "Wheel Reward",
        "V" : "Wheel Reward",
        "W" : "Wheel Reward",
        "X" : "Wheel Reward",
        "Y" : "Wheel Reward",
        "Z" : "Wheel Reward",
        "AA" : "Wheel Reward",
        "LB" : "Login Reward",
        "AE" : "Wheel Reward",
        "AF" : "Wheel Reward",
        "WD1": "Weekly Mission",
        "WD2": "Weekly Mission",
        "WD3": "Weekly Mission",
        "WD4": "Weekly Mission",
        "WD5": "Weekly Mission",
        "WD6": "Weekly Mission",
        "WD7": "Weekly Mission",
        "WD8": "Weekly Mission",
        "WD9": "Weekly Mission",
        "WD10": "Weekly Mission",
        "WD11": "Weekly Mission",
        "WD12": "Weekly Mission",
        "WD13": "Weekly Mission",
        "WD14": "Weekly Mission",
        "WD15": "Weekly Mission",
        "WD16": "Weekly Mission",
        "WD17": "Weekly Mission",
        "WD18": "Weekly Mission",
        "WD19": "Weekly Mission",
        "WD20": "Weekly Mission",
        "MT1": "Turnover Mission",
        "MT2": "Turnover Mission",
        "MT3": "Turnover Mission",
        "MT4": "Turnover Mission",
        "MT5": "Turnover Mission",
        "MT6": "Turnover Mission",
        "MT7": "Turnover Mission",
        "MT8": "Turnover Mission",
        "MT9": "Turnover Mission",
        "R1": "Retention",
        "R2": "Retention",
        "R3": "Retention",
        "R4": "Retention",
        "R5": "Retention",
        "R6": "Retention",
        "R7": "Retention",
        "R8": "Retention",
        "R9": "Retention",
        "R10": "Retention",
        "R11": "Retention",
        "R12": "Retention",
        "R13": "Retention",
        "R14": "Retention",
        "R15": "Retention",
        "R16": "Retention",
        "R17": "Retention",
        "R18": "Retention",
        "R19": "Retention",
        "R20": "Retention",
        "R21": "Retention",
        "R22": "Retention",
        "R23": "Retention",
        "R24": "Retention",
        "R25": "Retention",
        "R26": "Retention",
        "R27": "Retention",
        "R28": "Retention",
        "R29": "Retention",
      },
      // rewards:[]
    }
  },
  computed: {
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    inboxList(){
      return this.$store.state.user.inbox
    },
    getBalance(){
      return this.$store.state.user.balance
    },
    rewards(){
      return this.$store.state.user.rewards
    }
  },
  watch:{
    sessionToken(newState, oldState){
      var vm = this
      if(newState === '' || newState === undefined){
        vm.$router.push("/").catch(err => {});
      }
    }
  },
  mounted(){
    $('link[rel="canonical"]').attr('href', `${window.location.protocol}//${window.location.hostname}/inbox`);
    this.getInbox()
  },
  methods:{
    getInbox(){
      if(this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.loading = true
        this.$store
          .dispatch("user/getInbox", { account_id, auth_token })
          .then(response => {
            this.loading = false
            this.feedback.success = response.success
            this.feedback.status = response.status
            if (this.feedback.success == true) {
              // this.rewards = response.data
              this.startRender = true
            } else {
              this.feedback.status = this.$t("error." + response.status)
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            this.loading = false
            this.feedback.success = false
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
            this.feedback.status = this.$t("error." + response.status)
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
          });
      }
    },
    claimAction(id){
      var vm = this
      if(this.$store.state.user.account.ongoing_wb === 1){
        this.$swal({
          title: vm.$tc("ui.attention"),
          text: "if you claim now, any existing free credit will be removed, is it ok to proceed?",
          showCancelButton: true,
          type: "info",
          confirmButtonText: "Claim Now",
          cancelButtonText: vm.$tc("ui.cancel"),
        }).then(result => {
          if (result.value) {
            vm.claimInbox(id)
          } else if (result.dismiss) {
            
          }
        });
      }else{
        vm.claimInbox(id)
      }  
    },
    claimInbox(id){
      if (this.sessionToken) {
        var vm = this
        let account_id = this.accountID
        let auth_token = this.sessionToken
        let inbox_id = id
        this.loading = true
        this.$store
          .dispatch("user/claimInbox", { account_id, auth_token, inbox_id })
          .then(response => {
            this.loading = false
            if (response.success == true) {
              this.$helpers.showDialog('success', this.$t('message.success_claim'), "success", this);
              // this.$swal({
              //   title: vm.$tc("message.success_claim"),
              //   type: "success"
              // }).then(result => {
              //   vm.$router.push("/slot").catch(error =>{})
              // });
              // this.$helpers.showDialog(this.$t('ui.success'), "", "success", this);
              this.getInbox()
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          })
          .catch(response => {
            this.loading = false
            if((typeof response.status) != 'object'){
              if(response.status === "ftd_required"){
                this.$swal({
                  customClass: {
                    confirmButton: 'btn-deposit',
                    cancelButton: 'btn-info'
                  },
                  // buttonsStyling: false,
                  title: vm.$tc("ui.attention"),
                  text: vm.$tc("message.list.ftd_required"),
                  type: "info",
                  showCancelButton: true,
                  confirmButtonText: vm.$tc("ui.deposit_now"),
                  cancelButtonText: "Live Chat",
                }).then(result => {
                  if (result.value) {
                    vm.$router.push("/deposit").catch(error =>{})                  
                  }else if (result.dismiss) {
                    if(result.dismiss === 'cancel'){
                      // $('#modal-tnc').modal('show')
                      LiveChatWidget.call("maximize");
                    }
                  }
                });
              }else{
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }
            }
          });
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.disabled-grey{
  background: #e5e5e5 !important
}
.statement-detail-left{
  color: #8470ff
}
.statement-single{
  border-bottom: none;
}
</style>